import * as ACT from '../actions/transactionActions';

export function transaction(state = {}, action) {
    switch (action.type) {


        case ACT.TRANSACTION_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };
        case ACT.TRANSACTION_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.TRANSACTION_ADD_ITEM:
            return {
                ...state,
                addItem: action.data,
            };
        case ACT.TRANSACTION_SET_ALL:
            return {
                ...state,
                list: action.data,
            };
        case ACT.TRANSACTION_USER_ID:
            return {
                ...state,
                transactionUserId: action.data,
            };


        case ACT.TRANSACTION_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.TRANSACTION_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };


        default:
            return state
    }
};
